import React, { useState, useEffect } from 'react'
import { Box, Typography, Stack } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { Users, Link, Award, Bell, Zap, Phone, Icon } from 'react-feather'
import { carouselContainerStyle } from './FeatureCarousel.styles'
import { Trans } from 'react-i18next'

interface Feature {
	title: string
	description: string
	icon: Icon
}

const features: Feature[] = [
	{
		title: 'onboarding.carousel.feature_1_title',
		description: 'onboarding.carousel.feature_1_description',
		icon: Users,
	},
	{
		title: 'onboarding.carousel.feature_2_title',
		description: 'onboarding.carousel.feature_2_description',
		icon: Link,
	},
	{
		title: 'onboarding.carousel.feature_3_title',
		description: 'onboarding.carousel.feature_3_description',
		icon: Award,
	},
	{
		title: 'onboarding.carousel.feature_4_title',
		description: 'onboarding.carousel.feature_4_description',
		icon: Bell,
	},
	{
		title: 'onboarding.carousel.feature_5_title',
		description: 'onboarding.carousel.feature_5_description',
		icon: Zap,
	},
	{
		title: 'onboarding.carousel.feature_6_title',
		description: 'onboarding.carousel.feature_6_description',
		icon: Phone,
	},
]

export default function FeatureCarousel() {
	const [currentIndex, setCurrentIndex] = useState(0)
	const { palette } = useTheme()

	useEffect(() => {
		const timer = setInterval(() => {
			setCurrentIndex((prevIndex) => (prevIndex + 1) % features.length)
		}, 5000)

		return () => clearInterval(timer)
	}, [])

	const { icon: Icon, title, description } = features[currentIndex]

	return (
		<Box sx={{ width: '100%', minHeight: '300px', position: 'relative' }}>
			<Stack direction="row" alignItems="center" spacing={2}>
				<Box sx={carouselContainerStyle(palette)}>
					<Box sx={{ mb: 2, color: palette.primary.main }}>
						<Icon size={32} />
					</Box>
					<Typography variant="h6" gutterBottom sx={{ color: palette.text.primary }}>
						<Trans i18nKey={title} />
					</Typography>
					<Typography variant="body1" sx={{ color: palette.text.secondary }}>
						<Trans i18nKey={description} />
					</Typography>
				</Box>
			</Stack>

			<Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, gap: 1 }}>
				{features.map((_, index) => (
					<Box
						key={index}
						onClick={() => setCurrentIndex(index)}
						sx={{
							width: 8,
							height: 8,
							borderRadius: '50%',
							backgroundColor: index === currentIndex ? palette.primary.main : palette.grey[300],
							transition: 'all 0.3s ease',
							cursor: 'pointer',
						}}
					/>
				))}
			</Box>
		</Box>
	)
}
